__turbopack_context__.v({
  "play": "GalleryItem-module-scss-module__k1zXZG__play",
  "play__icon": "GalleryItem-module-scss-module__k1zXZG__play__icon",
  "player": "GalleryItem-module-scss-module__k1zXZG__player",
});
